import { render, staticRenderFns } from "./projectStatistics.vue?vue&type=template&id=fced7d78&scoped=true&"
import script from "./projectStatistics.vue?vue&type=script&lang=js&"
export * from "./projectStatistics.vue?vue&type=script&lang=js&"
import style0 from "./projectStatistics.vue?vue&type=style&index=0&id=fced7d78&prod&lang=less&"
import style1 from "./projectStatistics.vue?vue&type=style&index=1&id=fced7d78&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fced7d78",
  null
  
)

export default component.exports